import { setCookie } from 'cookies-next/server';
import { NextRequest, NextResponse } from 'next/server';

import { slashes } from '@sola/utils/url.ts';

export const defaultCookieOptions = {
  maxAge: 60 * 60 * 24 * 30,
  sameSite: 'strict' as const,
  secure: true,
};

export type ReferrerCookieData = {
  isReferrer: boolean;
  referrer: string | undefined;
  shouldRedirect: boolean;
};

// todo: can we consolidate this so that the compex stuff uses the new referrer cookie?
export const setCICookie = (
  searchParams: URLSearchParams,
  setCookiesFor: string[],
): void => {
  searchParams.forEach((value, key) => {
    if (setCookiesFor.includes(key)) {
      setCookie(key, value, defaultCookieOptions);
    }
  });
};

export const setReferrerCookie = (
  referrer: string,
  req: NextRequest,
  res: NextResponse,
): void => {
  setCookie('ci_cookie', referrer, {
    // maxAge omitted to make it a session cookie
    domain: 'compassion.com',
    secure: true,
    req,
    res,
  });
};

/**
 * @deprecated This is now defunct with new SDG utils, marked for removal.
 */
export const setSourceCodeCookie = (
  sourceCode: string,
  req: NextRequest,
  res: NextResponse,
): void => {
  setCookie('sourceCode', sourceCode, {
    domain: 'compassion.com',
    secure: true,
    httpOnly: true,
    req,
    res,
  });
};

export const assembleReferrerObject = (
  referrer?: string,
  path?: string,
): ReferrerCookieData => {
  if (!referrer && !path) {
    return { isReferrer: false, referrer: undefined, shouldRedirect: false };
  }

  const cleanedPath = slashes(path, 'none');

  const isPathNumber = Boolean(
    cleanedPath && Number.isInteger(Number(cleanedPath)),
  );

  let finalReferrer: string | undefined;

  if (isPathNumber) {
    finalReferrer = cleanedPath;
  } else {
    finalReferrer = referrer;
  }

  return {
    isReferrer: Boolean(finalReferrer),
    referrer: finalReferrer,
    shouldRedirect: isPathNumber,
  };
};

export const getSourceCodeFromRequest = (
  req: NextRequest,
): ReferrerCookieData => {
  let referrer =
    req.nextUrl.searchParams.get('referrer') ||
    req.nextUrl.searchParams.get('referer') ||
    undefined;

  const segments = req.nextUrl.pathname.split('/').filter(Boolean);
  const isPartnerRoute = segments[0] === 'partner' && segments[1];
  if (!referrer && isPartnerRoute) {
    referrer = segments[1];
  }

  const path = req.nextUrl.pathname;

  return assembleReferrerObject(referrer, path);
};
